export default "__VITE_ASSET__1a63a81b__"